import { responseHero } from '../utils/axiosInterceptor';
import { DaisyPayoutRegister } from '../models/daisypayoutregister.model';

export const removeDaisyPayoutRegister = async (id: number): Promise<DaisyPayoutRegister> => {
  const response = await responseHero.delete(`${process.env.REACT_APP_API_URL}/payoutregister/daisy/${id}`);
  return response.data;
};